/* global csrf_token */
import React from 'react';
import './subscribeField.scss';
import _ from 'underscore';
import $ from 'jquery';

class SubscribeField extends React.Component{
  constructor(props){
    super(props);
    const csrf_token = csrf_token || $('meta[name="csrf-token"]').attr('content');
    const user = FW.store.get('user');
    const email = user ? user.get('email') : '';
    this.state = {
      value: {
        csrf_token,
        email,
        user_id: user ? user.get('id') : null
      }
    }
  }

  subscribe = () => {
    if(this.state.value.email) {
      const data = this.state.value;
      $.post(`/blog/${this.props.blogSlug}/subscribe`, data).done((data)=>{
        swal.fire('Subscribed', 'You have subscribed successfully!', 'success');
      }).fail((xhr, status, error)=>{
        const data = xhr.responseJSON;
        const message = data.message;
        swal.fire('Uh oh...', message, 'error');
      });
    }
  };

  valueChanged = (key, e) => {
    const value = e.target.value;
    const previousValue = _.clone(this.state.value);
    previousValue[key] = value;
    this.setState({
      value: previousValue
    });
  };

  render(){
    return <div id={'blogSubscribeField'}>
      <input type="hidden" name="_token" value={this.state.value.csrf_token}/>
      <input type={'email'} name={'email'} id={'email'} value={this.state.value.email} onChange={this.valueChanged.bind(this, 'email')}/>
      {this.state.value.user_id ? <input type={'hidden'} name={'user_id'} id={'user_id'} value={this.state.value.user_id}/> : null}
      <a className={'btn btn-primary'} type={'submit'} aria-disabled={!this.state.value.email} onClick={this.subscribe}>Subscribe Via Email</a>
    </div>
  }
}

export default SubscribeField;
